"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionEnum = void 0;
const zod_1 = require("zod");
const sections = [
    'flight',
    'accommodation',
    'transport',
    'general-activity',
    'parking',
    'hire-car',
];
exports.SectionEnum = zod_1.z.enum(sections);
